import type { BankPartnerAccountName } from '@/types/WalletType';

export const BRIDGE_ACCOUNT_STATUS = {
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  AVAILABLE: 'AVAILABLE',
  IN_PROGRESS: 'IN_PROGRESS',
  CREATED: 'CREATED',
} as const;

export const BRIDGE_ACCOUNT_PARTNERS = {
  BRIDGE: 'BRIDGE',
  BRIDGE_SC: 'BRIDGE_SC',
} as const;

export const BRIDGE_ACCOUNT_CURRENCY = {
  USDT: 'USDT',
  USDC: 'USDC',
} as const;

export const STABLECOIN_ACTIVATION_LOADER_MESSAGES = [
  'Activando tu cuenta de stablecoins...',
  'Estamos verificando tu información...',
  'En unos minutos tu cuenta estará lista para recibir en USDC y USDT',
] as const;

export const STABLECOIN_ACTIVATION_MESSAGE_ROTATION_SECONDS = 5;

export const BRIDGE_ACCOUNT_CONFIG: Record<
  BankPartnerAccountName,
  {
    errorMap: Record<string, string>;
    successMessage: string;
  }
> = {
  BRIDGE_SC: {
    errorMap: {
      CUSTOMER_ACCOUNT_NEED_ATTENTION:
        'No pudimos completar tu solicitud, por favor contacta a tu ejecutivo',
    },
    successMessage: 'En unos minutos tu cuenta estará lista para recibir en USDC y USDT',
  },
  BRIDGE: {
    errorMap: {
      CUSTOMER_ACCOUNT_NEED_ATTENTION:
        'No pudimos completar tu solicitud de cuenta en Estados Unidos, por favor contacta a tu ejecutivo',
    },
    successMessage: 'Estamos verificando tu información. Te notificaremos cuando tu cuenta este activa, esto puede tomar unos minutos.',
  },
};

export type BridgeAccountStatus = 
  (typeof BRIDGE_ACCOUNT_STATUS)[keyof typeof BRIDGE_ACCOUNT_STATUS];

export type BridgeAccountPartner = 
  (typeof BRIDGE_ACCOUNT_PARTNERS)[keyof typeof BRIDGE_ACCOUNT_PARTNERS];



